var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#2EC086"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 10.2501V8.16675C8.6665 7.72472 8.8421 7.3008 9.15466 6.98824C9.46722 6.67567 9.89114 6.50008 10.3332 6.50008H13.5832C13.8619 6.49735 14.1369 6.56457 14.3829 6.6956C14.629 6.82662 14.8382 7.01727 14.9915 7.25008L15.6665 8.25008C15.8183 8.48052 16.0249 8.66968 16.2678 8.80058C16.5107 8.93148 16.7822 9.00003 17.0582 9.00008H23.6665C24.1085 9.00008 24.5325 9.17567 24.845 9.48824C25.1576 9.8008 25.3332 10.2247 25.3332 10.6667V19.0001C25.3332 19.4421 25.1576 19.866 24.845 20.1786C24.5325 20.4912 24.1085 20.6667 23.6665 20.6667H10.3332C9.95468 20.6787 9.5834 20.5615 9.28046 20.3342C8.97752 20.107 8.76098 19.7834 8.6665 19.4167M8.6665 14.8334H16.9998",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1665 12.3335L8.6665 14.8335L11.1665 17.3335",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputIcon);
export default __webpack_public_path__ + "static/media/outputIcon.94101903d2652636b987d9a39c0c4608.svg";
export { ForwardRef as ReactComponent };